import api from './api';

const historicalPaymentService = {
  // List historical payments
  getPayments: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/historical-payments/?${queryString}`);
    return response.data;
  },

  // Get payment statistics
  getStats: async (contactId = null) => {
    const params = contactId ? `?contact_id=${contactId}` : '';
    const response = await api.get(`/historical-payments/stats${params}`);
    return response.data;
  },

  // Get single payment
  getPayment: async (paymentId) => {
    const response = await api.get(`/historical-payments/${paymentId}`);
    return response.data;
  },

  // Create new payment
  createPayment: async (paymentData) => {
    const response = await api.post('/historical-payments/', paymentData);
    return response.data;
  },

  // Update payment
  updatePayment: async (paymentId, paymentData) => {
    const response = await api.put(`/historical-payments/${paymentId}`, paymentData);
    return response.data;
  },

  // Delete payment
  deletePayment: async (paymentId) => {
    const response = await api.delete(`/historical-payments/${paymentId}`);
    return response.data;
  },

  // Upload check image
  uploadCheckImage: async (paymentId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`/historical-payments/${paymentId}/check-image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Fetch the check image WITH the Authorization header and hand back an object URL.
  // (2026-09-07: the old form put the session JWT in the image URL's query string —
  // an <img>/<a> cannot carry a header, and a URL is written to every access log.
  // The backend never read that query parameter, so the link was broken as well.)
  getCheckImageBlobUrl: async (paymentId) => {
    const response = await api.get(`/historical-payments/${paymentId}/check-image`, { responseType: 'blob' });
    return URL.createObjectURL(response.data);
  },

  // Open the check image in a new tab without a credential in any URL.
  openCheckImage: async (paymentId) => {
    const url = await historicalPaymentService.getCheckImageBlobUrl(paymentId);
    window.open(url, '_blank', 'noopener');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  },

  // Delete check image
  deleteCheckImage: async (paymentId) => {
    const response = await api.delete(`/historical-payments/${paymentId}/check-image`);
    return response.data;
  }
};

export default historicalPaymentService;
